var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H16C20.4183 0 24 3.58172 24 8V16C24 20.4183 20.4183 24 16 24H8C3.58172 24 0 20.4183 0 16V8Z",
    fill: "#5062F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8888 7C10.7251 7 10.5691 7.06442 10.4549 7.17751C10.3408 7.29043 10.2777 7.4425 10.2777 7.6V8.2H13.7221V7.6C13.7221 7.4425 13.659 7.29043 13.5449 7.17751C13.4307 7.06442 13.2747 7 13.111 7H10.8888ZM14.7221 8.2V7.6C14.7221 7.17402 14.5512 6.76652 14.2485 6.46686C13.9459 6.16736 13.5367 6 13.111 6H10.8888C10.4631 6 10.0539 6.16736 9.75135 6.46686C9.44866 6.76652 9.27768 7.17402 9.27768 7.6V8.2H7.5C7.22386 8.2 7 8.42386 7 8.7C7 8.97614 7.22386 9.2 7.5 9.2H7.61102V16.4C7.61102 16.826 7.78199 17.2335 8.08468 17.5331C8.3872 17.8326 8.79645 18 9.22213 18H14.7777C15.2034 18 15.6126 17.8326 15.9151 17.5331C16.2178 17.2335 16.3888 16.826 16.3888 16.4V9.2H16.5C16.7761 9.2 17 8.97614 17 8.7C17 8.42386 16.7761 8.2 16.5 8.2H14.7221ZM8.61102 9.2V16.4C8.61102 16.5575 8.67417 16.7096 8.78823 16.8225C8.90245 16.9356 9.05844 17 9.22213 17H14.7777C14.9414 17 15.0974 16.9356 15.2116 16.8225C15.3256 16.7096 15.3888 16.5575 15.3888 16.4V9.2H8.61102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.8dcf3a7e91dec4cb95fdca07a7c3699e.svg";
export { ForwardRef as ReactComponent };